import { render, staticRenderFns } from "./RevisionHeader.vue?vue&type=template&id=6287ccc7&scoped=true&"
import script from "./RevisionHeader.vue?vue&type=script&lang=js&"
export * from "./RevisionHeader.vue?vue&type=script&lang=js&"
import style0 from "./RevisionHeader.vue?vue&type=style&index=0&id=6287ccc7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6287ccc7",
  null
  
)

export default component.exports